import { useQuery } from 'react-query';
import EmploymentStatusService from '../../../../services/employmentStatusService';
import type { EmploymentStatus } from '../../../../containers/App/types';

export type UseAllEmploymentStatusesReturn = {
  employmentStatuses: Array<EmploymentStatus>,
  isLoading: boolean,
  isError: boolean,
};

export default function useAllEmploymentStatuses(): UseAllEmploymentStatusesReturn {
  const queryKey = 'employment-statuses';
  const employmentStatusService = new EmploymentStatusService();

  const { data, isLoading, isError } = useQuery(
    queryKey,
    () => {
      return employmentStatusService.getAll();
    },
    { initialData: [], refetchOnWindowFocus: false },
  );

  return {
    employmentStatuses: data || [],
    isLoading,
    isError,
  };
}
